SC.purchase_series = (function () {
  var api = {};

  var init = function init() {
    handlers();
    filterRegionDropdown();
    changeRegionSeries();
    getSeriesGrid();
    changeSeriesMenuHandlers();
    setBodyClassBubblerByMenuActived();
  };
    // Hide regions based on current country
  var filterRegionDropdown = function filterRegionDropdown() {
    var currentCountryIso = $('.find-a-class .active-region').attr('data-country-iso');

    $('.change-region-container .region-select-row li a[data-country-iso!="' + currentCountryIso + '"]')
      .slice(1)
      .parent('li')
      .remove();
  };

  // Update the available series with an AJAX call if user clicks new region in dropdown
  var getSeriesGrid = function getSeriesGrid() {
    $('.js-series-page .region-select-row a').on('click', function (e) {
      e.preventDefault();
      // Get the region and the current active menu on the page
      var $selectedRegion = $(this);
      var regionId = $selectedRegion.data('id');
      var activeMenu = $('.js-series-page').data('menu');
      var url = '/series/json/' + regionId + '/' + '?active-menu=' + activeMenu;

      $.ajax({
        type: 'get',
        url: url,
        dataType: 'json',
        success: function (data) {
          var changeRegionBtn = document.getElementById('region_button');
          var $regionLinks = $('.region-select-row a');
          var $amenities = $('#amenities-shoes');

          // Update usable regions and purchasable series
          $('.transfer-info').html(data.usable_regions);
          $('.cycle-series-container .class-packages').html(data.purchasable_cycle_series);
          if (data.purchasable_renewable_series) {
            $('.cycle-series-container .renewable-packages').html(data.purchasable_renewable_series);
            $('.cycle-series-container #series-renew').show();
            $('.series-renew-quicklink').show();
          } else {
            $('.cycle-series-container .renewable-packages').html('');
            $('.cycle-series-container #series-renew').hide();
            $('.series-renew-quicklink').hide();
          }

          var isVegas = (regionId === 25);
          // Toggles class on Shoe amenities tool tip in Las Vegas region.
          if (isVegas) {
            $amenities.addClass('visible');
          } else {
            $amenities.removeClass('visible');
          }

          // Update the active menu on the container
          $('.js-series-page').data('menu', data.active_menu);

          // Get the target by the current menu from the return data (Use this instead of activeMenu in case no Annex tab)
          var target = $('.series-tab-header' + "[data-menu='" + data.active_menu + "']");
          var seriesContainerName = data.active_menu + '-series-container';

          changeSeriesMenu(target, seriesContainerName);

          // Change the series bubbles state if you are changing the series menu
          setBodyClassBubblerByMenuActived();

          // UI update selected region and close menu
          $('.change-region-series .region').html($selectedRegion.html());
          $regionLinks.removeClass('active');
          $regionLinks.removeAttr('aria-selected');
          $selectedRegion.addClass('active');
          $selectedRegion.attr('aria-selected', 'true');
          $('.region-cc').removeClass('block');
          changeRegionBtn.focus();
          changeRegionBtn.setAttribute('aria-expanded', 'false');
        },

        error: function () {
          confirmation(null, 'Oops! An error occurred while submitting your request. Try that again!');
        }
      });
    });
  };

  // Switch from current active series menu to the selected Activity (i.e. Annex)
  var changeSeriesMenuHandlers = function changeSeriesMenuHandlers() {
    var $buyClassesContainer = $('.js-series-page');
    var opacityMid  = { 'opacity': 0.54 };
    var opacityFull = { 'opacity': 1 };

    var mouseEnter = function mouseEnter(e) {
      $(e.currentTarget).css(opacityMid);
      $('.series-tab-header.active span').css(opacityMid);
    };

    var mouseLeave = function mouseLeave(e) {
      $(e.currentTarget).css(opacityFull);
      $('.series-tab-header.active span').css(opacityFull);
    };

    enquire.register('screen and (min-width: 1024px)', {
      // Triggered when a media query matches.
      match: function () {
        $buyClassesContainer.on({mouseenter: mouseEnter, mouseleave: mouseLeave}, '.cycle-active');

        $buyClassesContainer.on('mouseenter', '.series-tab-header', function (e) {
          var $currentTarget = $(e.currentTarget);
          $currentTarget.children('span').css(opacityMid);

          if ($currentTarget.hasClass('active')) {
            $('.active-tab').css(opacityMid);
          }
        });

        $buyClassesContainer.on('mouseleave', '.series-tab-header', function (e) {
          var $currentTarget = $(e.currentTarget);
          $currentTarget.children('span').css(opacityFull);

          if ($currentTarget.hasClass('active')) {
            $('.active-tab').css(opacityFull);
          }
        });
      },

      // Triggered when the media query transitions
      unmatch: function () {
        $buyClassesContainer.off('mouseenter mouseleave', '.cycle-active');
        $buyClassesContainer.off('mouseenter mouseleave', '.series-tab-header');
      }
    });

    $buyClassesContainer.on('click keydown', '.series-tab-header', function (e) {
      if (e.type === 'keydown' && e.key !== 'Enter') {
        return;
      }

      var $currentTarget = $(e.currentTarget);
      var activeMenu = $('.js-series-page').data('menu');
      var clickedMenu = $currentTarget.data('menu');
      var activeTabClass = activeMenu + '-active';
      var clickedTabClass = clickedMenu + '-active';
      var seriesContainerName = clickedMenu + '-series-container';

      $('.' + activeTabClass).removeClass(activeTabClass).addClass(clickedTabClass);
      changeSeriesMenu(e.currentTarget, seriesContainerName);
      $('.js-series-page').data('menu', clickedMenu);

      setBodyClassBubblerByMenuActived();
    });
  };

  var changeSeriesMenu = function changeSeriesMenu(currentTarget, seriesContainerName) {
    // Remove active class from all tabs and add active to this tab
    $('.series-tab-header').removeClass('active').attr('aria-selected', 'false');
    $(currentTarget).addClass('active').attr('aria-selected', 'true');

    // Remove active class from current class packages and add to current page
    $('.js-series-container').removeClass('active').hide();
    $('.' + seriesContainerName).addClass('active').show();
  };

  var hoverInfo = function ($this, status) {
    if (status === 'show') {
      $this.siblings('.credits-additional-info').addClass('block');
    } else {
      $this.children('.credits-additional-info').removeClass('block');
    }
  };

  var changeRegionSeries = function () {
    var changeRegionBtn = document.getElementById('region_button');
    var regionList = document.getElementsByClassName('region-cc')[0];

    var regionBtnEvent = function (e) {
      e.stopPropagation();
      e.preventDefault();

      if (regionList.classList.contains('block')) {
        regionList.classList.remove('block');
        regionList.setAttribute('aria-hidden', 'true');
        changeRegionBtn.setAttribute('aria-expanded', 'false');
      } else {
        regionList.classList.add('block');
        regionList.removeAttribute('aria-hidden');
        changeRegionBtn.setAttribute('aria-expanded', 'true');

        setTimeout(function () {
          regionList.getElementsByTagName('a')[1].focus();
        }, 0);
      }
    };

    changeRegionBtn.addEventListener('click', function (e) {
      regionBtnEvent(e);
    });

    regionList.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        regionList.classList.remove('block');
        regionList.setAttribute('aria-hidden', 'true');
        changeRegionBtn.setAttribute('aria-expanded', 'false');
        changeRegionBtn.focus();
      }
    });

    regionList.addEventListener('focusout', function (e) {
      if (regionList.contains(e.relatedTarget)) {
        return;
      }

      setTimeout( function () {
        regionList.classList.remove('block');
        changeRegionBtn.setAttribute('aria-expanded', 'false');
        regionList.setAttribute('aria-hidden', 'true');
      }, 100);
    });

    $('html').click(function () {
      regionList.classList.remove('block');
      regionList.setAttribute('aria-hidden', 'true');
      changeRegionBtn.setAttribute('aria-expanded', 'false');
    });
  };

  var logSeriesAddToBag = function logSeriesAddToBag($form) {
    var $productInfo = $form.find('.product-info');
    var seriesName = String($productInfo.data('series-name'));
    var productName = seriesName === '1' ? 'A single class.' : 'A set of ' + seriesName + ' classes.';
    var baseSku = $productInfo.data('series-id');
    var sku = SC.utils.getSku('Series', baseSku, seriesName);
    var attrs = {'Base Sku': baseSku};
    var unitPrice = $productInfo.data('series-price').slice(1);
    var quantity = $productInfo.find('[name="quantity"]').first().val();
    var category = $productInfo.data('analytics-category');
    var product = SC.analytics.mp.createProduct(
      productName,
      sku,
      unitPrice,
      quantity,
      category,
      attrs
    );

    SC.analytics.mp.setCurrencyCode($productInfo.data('currency-code'));
    SC.analytics.mp.logProductEvent('AddToCart', product, {'Location': 'Series'});
  };

  // Basic handlers mostly taken from soulcycle.js
  var handlers = function handlers() {
    var $seriesContainer = $('.js-series-page');

    $seriesContainer.on('submit', '.add-series-form', function () {
      logSeriesAddToBag($(this));
    });

    // Below 1024px the button is visually hidden, so the whole card is the touch target;
    // submitting through the form keeps the submit-handler analytics firing exactly once.
    $seriesContainer.on('click', '.pack-card', function (e) {
      if (window.innerWidth >= 1024) {
        return;
      }

      if ($(e.target).closest('.credits-additional-info, .more-info-icon, .form-button').length) {
        return;
      }

      var $form = $(this).find('.add-series-form');

      if (!$form.find('.form-button').length) {
        return;
      }

      var form = $form.get(0);

      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        $form.trigger('submit');
      }
    });

    $seriesContainer.on('mouseenter', '.more-info-icon', function (e) {
      var $this = $(e.currentTarget);
      hoverInfo($this, 'show');
      $this.attr('aria-expanded', 'true');
    });

    $seriesContainer.on('mouseleave focusout', '.credits-additional-info', function (e) {
      if (e.type === 'focusout' && $(e.currentTarget).has(e.relatedTarget).length) {
        return;
      }
      $(e.currentTarget).siblings('.more-info-icon').attr('aria-expanded', 'false').focus();
      $(e.currentTarget).removeClass('block');
    });

    $seriesContainer.on('keydown', '.credits-additional-info', function (e) {
      if (e.key !== 'Escape') {
        return;
      }

      var $tooltip = $(e.currentTarget);
      $tooltip.removeClass('block');
      $tooltip.siblings('.more-info-icon').attr('aria-expanded', 'false').focus();
    });

    $seriesContainer.on('click', '.more-info-icon', function (e) {
      var $this = $(e.currentTarget);
      hoverInfo($this, 'show');
      $this.attr('aria-expanded', 'true');
      $this.siblings('.credits-additional-info').find('.close-more-info').focus();
    });

    $seriesContainer.on('click', '.close-more-info', function (e) {
      e.stopPropagation();
      $(this).parent('.credits-additional-info')
        .removeClass('block')
        .siblings('.more-info-icon')
        .attr('aria-expanded', 'false');
    });

    $seriesContainer.on('click', '.region-select-row li a', function (e) {
      /**
       * mParticle sendEvent - Click New Region - Series Page
       * Sends an mParticle event with a custom GA label.
       */
      var region = $(e.currentTarget).data('region-name');
      var eventData = {
        'Location': 'Series',
        'Region Name': region
      };
      SC.analytics.mp.sendEvent('Click New Region', 'navigation', eventData, 'Series');
    });

    // Scrollspy for in-page navigation links with responsive activation offset
    const sections = document.querySelectorAll('#memberships, #class-packs, #gift-cards');
    const navLinks = document.querySelectorAll('.series__inpage-nav .quick-links a');

    // Adjust rootMargin based on viewport height and width dynamically for better small screen behaviour
    const activationOffsetPointFromTop = window.innerWidth <= 640 ? 180 : 300;
    const offsetPercentage = (activationOffsetPointFromTop / window.innerHeight) * 100;
    const rootMargin = `-${offsetPercentage - 15}% 0px -${100 - offsetPercentage - 10}% 0px`;

    const observerOptions = {
      root: null,
      rootMargin: rootMargin,
      threshold: 0
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const id = entry.target.id;
          navLinks.forEach(link => {
            link.classList.remove('active');
          });
          const activeLink = document.querySelector(`.quick-links a[href="#${id}"]`);
          if (activeLink) {
            activeLink.classList.add('active');
          }
        }
      });
    }, observerOptions);

    sections.forEach(section => {
      observer.observe(section);
    });
  };

  var setBodyClassBubblerByMenuActived = function setBodyClassBubblerByMenuActived() {
    var prefixClass = 'series-bubbler-';
    var currentMenuActived = $('.js-series-page').data('menu');

    $('body').removeClass(prefixClass + 'annex')
      .removeClass(prefixClass + 'cycle')
      .addClass(prefixClass + currentMenuActived);
  };

  init();
  return api;
})();
